import React from 'react';
import styled from 'styled-components';

import { Typography } from 'src/typography';
import { WhatIsPayByBank } from 'src/payments/components/what-is-pbb';

type PointsBoostCartTreatmentProps = {
  // Display label from the points-boost foundation (e.g. "2x"); never a dollar amount.
  label: string;
};

// Points advertisement only: no terms link (per design) and deliberately no incentive
// exposure emission — the shared reward-agnostic exposure follow-up owns that later.
export const PointsBoostCartTreatment = ({ label }: PointsBoostCartTreatmentProps): JSX.Element => (
  <Wrapper>
    <Subline data-testid='cart-points-boost-treatment' size='xsmall'>
      Get <strong>{label} loyalty points</strong> on orders paid by bank.
    </Subline>
    <WhatIsPayByBank />
  </Wrapper>
);

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    justify-content: space-between;
    flex-direction: row;
  }
`;

const Subline = styled(Typography.Body)`
  color: var(--dcm-cart-points-boost-text-color, ${({ theme }) => theme.colors.dutchiePayGreen});
  text-align: center;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    text-align: left;
  }
`;
